import { useEffect, useState } from 'react';

import { useAccountSettings } from '~/components/api/useAccountSettings';

type MatchRateData = any;
type MatchRateArguments = {
  refresh?: boolean;
};
export function useMatchRates() {
  const { secretToken } = useAccountSettings();
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [matchRateData, setMatchRateData] = useState<MatchRateData>(null);

  useEffect(() => {
    if (secretToken) {
      fetchMatchRateData();
    }
  }, [secretToken]);

  async function fetchMatchRateData({
    refresh = false,
  }: MatchRateArguments = {}) {
    try {
      const result = await fetch(
        `/api/growth-tools/crm-match-rates?refresh=${refresh}`,
        {
          headers: {
            Authorization: `Bearer ${secretToken}`,
          },
        },
      );

      const data = await result.json();
      setMatchRateData(data);
    } catch (error) {
      setHasError(true);
    } finally {
      setLoading(false);
    }
  }

  async function handleRefresh() {
    setLoading(true);
    setMatchRateData(null);
    fetchMatchRateData({ refresh: true });
  }

  return {
    loading,
    hasError,
    data: matchRateData,
    refresh: handleRefresh,
  };
}
